import http from '@/services/http';

const BASE = 'comisiones/';

export default {
  namespaced: true,

  state: () => ({
    liquidaciones: [],
    liquidacion: null,
    loading: false,
    error: null,
  }),

  getters: {
    all: (state) => state.liquidaciones,
    current: (state) => state.liquidacion,
    isLoading: (state) => state.loading,
    hasError: (state) => state.error,
  },

  mutations: {
    SET_LIQUIDACIONES(state, value) {
      state.liquidaciones = value;
    },
    SET_LIQUIDACION(state, value) {
      state.liquidacion = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_ERROR(state, value) {
      state.error = value;
    },
  },

  actions: {
    async fetchLiquidaciones({ commit }, filters = {}) {
      try {
        commit('SET_LOADING', true);
        const params = {};
        if (filters.id_vendedor)    params.id_vendedor = filters.id_vendedor;
        if (filters.estado)         params.estado = filters.estado;
        if (filters.periodo_inicio) params.periodo_inicio = filters.periodo_inicio;
        if (filters.periodo_fin)    params.periodo_fin = filters.periodo_fin;

        const { data } = await http.get(BASE + 'liquidaciones', { params });
        commit('SET_LIQUIDACIONES', data.data || []);
        commit('SET_ERROR', null);
        return data;
      } catch (error) {
        commit('SET_ERROR', error.message || 'Error al cargar liquidaciones');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async fetchLiquidacion({ commit }, id) {
      try {
        commit('SET_LOADING', true);
        const { data } = await http.get(BASE + `liquidaciones/${id}`);
        commit('SET_LIQUIDACION', data.data || null);
        commit('SET_ERROR', null);
        return data.data;
      } catch (error) {
        commit('SET_ERROR', error.message || 'Error al cargar liquidación');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async crearBorrador({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const { data } = await http.post(BASE + 'liquidaciones', payload);
        commit('SET_LIQUIDACION', data.data || null);
        commit('SET_ERROR', null);
        return data.data;
      } catch (error) {
        commit('SET_ERROR', error.message || 'Error al crear borrador');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async agregarConcepto({ commit }, { id, concepto }) {
      try {
        commit('SET_LOADING', true);
        const { data } = await http.post(BASE + `liquidaciones/${id}/conceptos`, concepto);
        commit('SET_LIQUIDACION', data.data || null);
        commit('SET_ERROR', null);
        return data.data;
      } catch (error) {
        commit('SET_ERROR', error.message || 'Error al agregar concepto');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async eliminarConcepto({ commit }, { id, conceptoId }) {
      try {
        commit('SET_LOADING', true);
        const { data } = await http.delete(BASE + `liquidaciones/${id}/conceptos/${conceptoId}`);
        commit('SET_LIQUIDACION', data.data || null);
        commit('SET_ERROR', null);
        return data.data;
      } catch (error) {
        commit('SET_ERROR', error.message || 'Error al eliminar concepto');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async recalcular({ commit }, id) {
      try {
        commit('SET_LOADING', true);
        const { data } = await http.post(BASE + `liquidaciones/${id}/recalcular`, {});
        commit('SET_LIQUIDACION', data.data || null);
        commit('SET_ERROR', null);
        return data.data;
      } catch (error) {
        commit('SET_ERROR', error.message || 'Error al recalcular liquidación');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async confirmar({ commit }, id) {
      try {
        commit('SET_LOADING', true);
        const { data } = await http.post(BASE + `liquidaciones/${id}/confirmar`, {});
        commit('SET_LIQUIDACION', data.data || null);
        commit('SET_ERROR', null);
        return data.data;
      } catch (error) {
        commit('SET_ERROR', error.message || 'Error al confirmar liquidación');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    // pagar delegates to the new /pagos endpoint (legacy /pagar is deprecated — 410)
    async pagar({ dispatch }, { id, monto, id_medio_pago, comprobante_ref, id_cuenta }) {
      return dispatch('registrarPago', { id, monto, id_medio_pago, comprobante_ref, id_cuenta });
    },

    async registrarPago({ commit }, { id, monto, id_medio_pago, comprobante_ref, id_cuenta }) {
      try {
        commit('SET_LOADING', true);
        const { data } = await http.post(
          BASE + `liquidaciones/${id}/pagos`,
          { monto, id_medio_pago, comprobante_ref, id_cuenta }
        );
        commit('SET_LIQUIDACION', data.data || null);
        commit('SET_ERROR', null);
        return data.data;
      } catch (error) {
        commit('SET_ERROR', error.message || 'Error al registrar pago');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async generarPdf(_, { id, tipo }) {
      const { data } = await http.get(BASE + `liquidaciones/${id}/pdf`, { params: { tipo } });
      return data.file_url;
    },
  },
};
